import React, { useState, useEffect, Fragment } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, BeenhereRounded, Visibility } from '@material-ui/icons';

//tabla y card components
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { Link } from 'react-router-dom';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 140 },
  { Header: 'Cód. Proveedor', accessor: 'CardCode' },
  { Header: 'Nombre Proveedor', accessor: 'CardName' },
  { Header: 'Descripción Grupo', accessor: 'description' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function ProviderGroup(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [providerGroups, setProviderGroups] = useState([]); //constante para el listado
  const [dataLoading, setDataLoading] = useState(false);

  //recargar Listado para usar en create y update
  async function listProviderGroup() {
    setDataLoading(true);
    let response = await wsGetAll('com/provider-group');
    setDataLoading(false);
    if (response.success) setProviderGroups(response.data);
  }

  useEffect(() => {
    listProviderGroup();
  }, []);

  return (
    <Fragment>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={listProviderGroup} />

      <Card>
        <CardHeader icon>
          <AllowedGuard
            permission={ConstantPermissions.COM_ZONE_QUOTAS_STORE}
            component={
              <CardIcon color="primary">
                <BeenhereRounded style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <CardIcon
              onClick={() => setOpen({})}
              pointer="true"
              color={props.themeContext.buttonColorSuccess}
            >
              <Add />
            </CardIcon>
          </AllowedGuard>
          <h4 className={classes.cardIconTitle}>Listado de grupos proveedor {dataLoading && <LoadingSpinner />}</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName="grupos_proveedor"
            defaultWidth={1000}
            columns={columns}
            data={providerGroups.map((item, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard permission={ConstantPermissions.COM_ZONE_QUOTAS_UPDATE}>
                      <Button
                        justIcon
                        round
                        simple
                        color={props.themeContext.buttonColorWarning}
                        onClick={() => setOpen(item)}
                      >
                        <Create />
                      </Button>
                    </AllowedGuard>
                    <AllowedGuard permission={ConstantPermissions.LOGI_PRODUCTS_UPDATE}>
                      <Button justIcon round simple size="sm">
                        <Link to={`${item.id}`}>
                          <Visibility />
                        </Link>
                      </Button>
                    </AllowedGuard>
                    <AllowedGuard permission={ConstantPermissions.COM_ZONE_QUOTAS_DELETED}>
                      <ButtonDelete
                        entity="com/provider-group"
                        id={item.id}
                        reload={listProviderGroup}
                      />
                    </AllowedGuard>
                  </div>
                ),
                CardCode: item.CardCode,
                CardName: item.CardName,
                description: item.description,
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </Fragment>
  );
});
